module.exports = __webpack_public_path__ + "img/space2.a02f5614.jpg";